"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impressionConfig = void 0;
exports.impressionConfig = {
    size: 32,
    colors: {
        nice: '#83D5F9',
        good: '#66BB6A',
        warning: '#FDE896',
        danger: '#EC9D9D',
    },
};
//# sourceMappingURL=general-impression.config.js.map